module.exports = __webpack_public_path__ + "static/media/xbomb.d3987eee.png";